import { CategoricalColumn, StringColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';
import { ESegmentStatus, NA_VALUE } from 'constant';

export const COL_NAMES = {
	_id: '_id',
	segmentId: 'segmentId',
	name: 'name',
	SegmentType: 'SegmentType',
	parentSegmentName: 'parentSegmentName',
	queryText: 'queryText',
	createdBy: 'createdBy',
	createdAt: 'createdAt',
	updatedBy: 'updatedBy',
	updatedAt: 'updatedAt',
	useCase: 'useCase',
	state: 'state',
	isRapid: 'isRapid',
	scheduledAtTimestamp: 'scheduledAtTimestamp'
};

export const columnConfigs = [
	StringColumn({
		title: 'Segment ID',
		minWidth: 100,
		maxWidth: 200,
		mapDataToValue: (data: any) => {
			const segmentId = data[COL_NAMES.segmentId];
			return segmentId ? String(segmentId) : EMPTY_STRING;
		}
	}),
	StringColumn({
		title: 'Segment Name',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.name] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Segment Type',
		minWidth: 200,
		maxWidth: 250,
		mapDataToValue: (data: any) => data[COL_NAMES.SegmentType] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Segment Status',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.state] || ESegmentStatus.ACTIVE
	}),
	StringColumn({
		title: 'Parent Segment Name',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.parentSegmentName] || EMPTY_STRING
	}),
	CategoricalColumn({
		title: 'Use Case',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.useCase] || EMPTY_STRING
	}),
	StringColumn({
		title: 'Created By',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.createdBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 200,
		maxWidth: 300,
		columnName: COL_NAMES.createdAt
	}),
	CategoricalColumn({
		title: 'Updated By',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.updatedBy] || EMPTY_STRING
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 200,
		maxWidth: 300,
		columnName: COL_NAMES.updatedAt
	}),
	CategoricalColumn({
		title: 'Is Rapid Segment',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => {
			const isRapid = data[COL_NAMES.isRapid];
			return isRapid ? 'True' : 'False';
		}
	}),
	StringColumn({
		title: 'Scheduled At Timestamp',
		minWidth: 200,
		maxWidth: 300,
		mapDataToValue: (data: any) => data[COL_NAMES.scheduledAtTimestamp] || NA_VALUE
	})
];

export const DEFAULT_CONFIG = {
	pageDetails: {
		pageNo: 1,
		pageSize: 20
	}
};
